import { FormattedMessage } from 'react-intl';

export const surveyMessages = {
  'survey.users.heading': (
    <FormattedMessage
      id="survey.users.heading"
      defaultMessage="Why are you joining Breedlogic?"
    />
  ),
  'survey.users.subHeading': (
    <FormattedMessage
      id="survey.users.subHeading"
      defaultMessage="Your response helps us tailor our platform to your needs and preferences."
    />
  ),
  'survey.users.skipButton': (
    <FormattedMessage
      id="survey.users.skipButton"
      defaultMessage="Skip question"
    />
  ),
  'survey.users.submitButton': (
    <FormattedMessage id="survey.users.submitButton" defaultMessage="Submit" />
  ),
  'survey.users.submittingButtonText': (
    <FormattedMessage
      id="survey.users.submittingButtonText"
      defaultMessage="Submitting..."
    />
  ),
  'survey.users.questions': [
    {
      id: '1',
      text: (
        <FormattedMessage
          id="survey.users.question1"
          defaultMessage="I want to make better decisions"
        />
      ),
    },
    {
      id: '2',
      text: (
        <FormattedMessage
          id="survey.users.question2"
          defaultMessage="I am a member of a Breed Society"
        />
      ),
    },
    {
      id: '3',
      text: (
        <FormattedMessage
          id="survey.users.question3"
          defaultMessage="I want to search for animals"
        />
      ),
    },
    {
      id: '4',
      text: (
        <FormattedMessage
          id="survey.users.question4"
          defaultMessage="I want to conduct research"
        />
      ),
    },
    {
      id: '5',
      text: (
        <FormattedMessage
          id="survey.users.question5"
          defaultMessage="I work at a Breed Society"
        />
      ),
    },
    {
      id: '6',
      text: (
        <FormattedMessage id="survey.users.question6" defaultMessage="Other" />
      ),
    },
  ],
};
